<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div class="slds-spinner_container" id="busy" title="{{message}}">
  <div class="slds-spinner {{size}} {{color}}" role="status">
    <span class="slds-assistive-text busy-message">{{message}}</span>
    <div class="slds-spinner__dot-a"></div>
    <div class="slds-spinner__dot-b"></div>
  </div>
</div>
